<!--
 * @Author: 汪俊洪
 * @Date: 2021-07-21 10:01:04
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-06 15:39:24
 * @Description: 回显ossFile
-->
<template>
  <div class="list" v-if="ossFiles.length > 0">
    <template v-if="isImage">
      <el-image class="preview" :src="ossFiles[0].url" :preview-src-list="list">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </template>
    <template v-else>
      <a
        :href="item.url"
        target="_blank"
        class="item"
        v-for="(item, index) in ossFiles"
        :key="index"
      >
        {{ item.fileName }}
      </a>
    </template>
  </div>
  <div v-else>
    -
  </div>
</template>

<script>
export default {
  props: {
    ossFiles: {
      type: Array,
      default: function () {
        return []
      }
    },
    isImage: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: []
    }
  },
  watch: {
    ossFiles: {
      handler () {
        this.list = this.ossFiles.map((item) => item.url)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  .item {
    display: block;
    line-height: 22px;
    cursor: pointer;
  }
}

.preview {
  display: block;
  width: 100px;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 30px;
  color: #909399;
  background: #e5e5e5;
}
</style>
